import React from "react";
import * as Sentry from "@sentry/react";

import ResultListCore from "./ResultListCore";
import ResultListHotelPicture from "./ResultListHotelPicture";
import ResultListHeading from "./ResultListHeading";
import ResultListOffer from "./ResultListOffer";

const ResultListResult = ({ isArea, ...rest }) => {
  let picture;
  const offer = <ResultListOffer {...rest} />;

  const { hotel } = rest.result;

  if (hotel.picture) {
    picture = (
      <ResultListHotelPicture
        link={hotel.url}
        picture={hotel.picture}
        hotelName={hotel.name}
      />
    );
  }

  return (
    <li
      className="clearfix"
      itemProp={isArea ? "containsPlace" : null}
      itemScope
      itemType="https://schema.org/Hotel"
    >
      <Sentry.ErrorBoundary
        beforeCapture={(scope) => {
          scope.setContext("hotel-result", rest.result);
        }}
      >
        {picture}
        <ResultListHeading hotel={hotel} />

        <div className="hotel-info">
          <div className="hotel-table">
            <div className="hotel-row">
              <div className="hotel-core">
                <ResultListCore {...hotel} />
              </div>
              <div className="hotel-pricing">{offer}</div>
            </div>
          </div>
        </div>
      </Sentry.ErrorBoundary>
    </li>
  );
};

export default ResultListResult;
